import { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	List,
	PageHeader,
	Row,
	Select,
	Spin,
} from "antd";

import {
	CheckPermission,
	ObjectNumbersToEnglish,
	PersianNumberToEnglish,
} from "scripts/helpers";
import { setRoute } from "scripts/reducer";
import { Permissions, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

const Component = ({ onSetRoute, parentName, permissions, routeName }) => {
	const initialState = { phoneNumbers: [] };
	const [state, setState] = useState(initialState);
	const { address, loaded, phoneNumbers, submitting } = state;
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				// values.phoneNumbers = values.phoneNumbers.map(({ type, number }) => ({
				// 	type: type,
				// 	number: PersianNumberToEnglish(number),
				// }));

				API.contact
					.update(values)
					.then(() => {})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });

		API.contact
			.details()
			.then(({ data }) => {
				if (permissions.update) {
					setState((prevState) => ({ ...prevState, loaded: true }));

					form.setFieldsValue(data);
				} else {
					setState((prevState) => ({
						...prevState,
						...data,
						loaded: true,
					}));
				}
			})
			.catch(() => {
				setState((prevState) => ({ ...prevState, loaded: true }));
			});
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader title={Resources.contactUs} />
			<Row className="sp-content-center">
				<Col xs={24} md={18} lg={12}>
					<Card>
						{loaded ? (
							permissions.update ? (
								<Form layout="vertical" form={form}>
									<>
										<Form.Item
											name="address"
											label={Resources.address}
											rules={Rules.required}
										>
											<Input.TextArea rows={6} />
										</Form.Item>
										<Row gutter={[16, 8]}>
											<Form.List name="phoneNumbers">
												{(fields, { add, remove }) => (
													<>
														{fields.map(({ key, name, ...restField }) => (
															<Fragment key={key}>
																<Col xs={14}>
																	<Form.Item
																		name={[name, "number"]}
																		label={Resources.number}
																		rules={Rules.required}
																		{...restField}
																	>
																		<Input className="sp-input-ltr" />
																	</Form.Item>
																</Col>
																<Col xs={8}>
																	<Form.Item
																		name={[name, "type"]}
																		label={Resources.type}
																		rules={Rules.required}
																		{...restField}
																	>
																		<Select
																			options={[
																				{
																					value: "mobile",
																					label: Resources.mobile,
																				},
																				{
																					value: "phone",
																					label: Resources.phone,
																				},
																				{
																					value: "fax",
																					label: Resources.fax,
																				},
																			]}
																		/>
																	</Form.Item>
																</Col>
																<Col xs={2}>
																	<Button
																		type="link"
																		onClick={() => remove(name)}
																		style={{
																			marginTop: 32,
																			padding: 0,
																		}}
																		block
																	>
																		<i className="fa fa-minus-circle" />
																	</Button>
																</Col>
															</Fragment>
														))}
														<Col xs={24}>
															<Form.Item>
																<Button
																	type="dashed"
																	onClick={() => add()}
																	block
																>{`${Resources.add} ${Resources.number}`}</Button>
															</Form.Item>
														</Col>
													</>
												)}
											</Form.List>
										</Row>
										<Button
											type="primary"
											onClick={handleSubmit}
											loading={submitting}
											style={{ float: "left", marginTop: 16 }}
										>
											{Resources.confirm}
										</Button>
									</>
								</Form>
							) : (
								<List>
									<List.Item>
										<List.Item.Meta
											title={Resources.address}
											description={
												<div
													dangerouslySetInnerHTML={{
														__html: address.replace(/\n/g, "<br />"),
													}}
												></div>
											}
										></List.Item.Meta>
									</List.Item>
									{phoneNumbers.map(({ number, type }, i) => (
										<List.Item key={i}>
											<List.Item.Meta
												title={`${Resources.number} ${
													type === Types.phoneNumbers.mobile
														? Resources.mobile
														: type === Types.phoneNumbers.phone
														? Resources.phone
														: Resources.fax
												}`}
												description={number}
											></List.Item.Meta>
										</List.Item>
									))}
								</List>
							)
						) : (
							<Spin className="sp-modal-spin" />
						)}
					</Card>
				</Col>
			</Row>
		</>
	);
};

export default connect(
	(state) => {
		return {
			permissions: {
				update: CheckPermission(
					state.user.permissions,
					Permissions.CONTACT_US_UPDATE
				),
			},
		};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
		};
	}
)(Component);
